<template>
  <div id="QuestionDocumentsComponent">
    <v-list>
      <v-list-item
        v-for="(document, index) in documentCopy"
        :key="index"
      >
        <v-list-item-action>
          <v-btn
            icon
            @click="removeOption(index)"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-list-item-action>

        <v-list-item-content>
          <v-text-field
            v-model="documentCopy[index].name"
            class="mt-0 pt-0"
            label="Option name"
            :rules="[
              ...Rules.required,
              ...Rules.max(documentCopy[index].name, 40),
            ]"
            :counter="40"
            autofocus
            readonly
          />
        </v-list-item-content>
      </v-list-item>

      <v-list-item @click="openNewDocumentDialog">
        <v-list-item-action>
          <v-btn icon>
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-list-item-action>

        <v-list-item-content>
          <v-list-item-title>New Document</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item @click="openExistingDocumentDialog">
        <v-list-item-action>
          <v-btn icon>
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-list-item-action>

        <v-list-item-content>
          <v-list-item-title>Existing Document</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-dialog
      v-model="addDialog"
      attach=".EditFormSectionComponent"
      max-width="500px"
    >
      <v-sheet class="pa-4 d-flex">
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="newFile.name"
              label="Name"
              placeholder="document name"
            />
          </v-col>
          <v-col cols="12">
            <v-file-input
              v-model="newFile.file"
              label="File upload"
              placeholder="Select your file..."
            >
              <template
                v-slot:append-outer
                class="mt-0"
              >
                <v-btn
                  class=""
                  color="primary"
                  :disabled="newFile.file===undefined"
                  fab
                  @click="addNewDocument"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
            </v-file-input>
          </v-col>
        </v-row>
      </v-sheet>
    </v-dialog>

    <v-dialog
      v-model="existingDialog"
      attach=".EditFormSectionComponent"
      max-width="500px"
    >
      <v-sheet class="pa-4 d-flex">
        <v-autocomplete
          v-model="search"
          label="Search for an existing document"
          :items="items"
          item-text="name"
          item-value="id"
          return-object
        />
        <v-spacer />
        <v-btn
          class="mt-2"
          color="primary"
          :disabled="search===''"
          fab
          @click="addExistingDocument"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-sheet>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: 'QuestionDocumentsComponent',
  props: {
    documents: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data: () => ({
    search: '',
    newFile: {
      name: '',
      file: undefined
    },
    addDialog: false,
    existingDialog: false,
    documentCopy: [],
    errors: null
  }),
  computed: {
    items () {
      return this.$store.state.documents.agencyDocuments
    }
  },
  created () {
    this.documentCopy = _.cloneDeep(this.documents)
  },
  methods: {
    openNewDocumentDialog () {
      this.addDialog = true
    },
    addNewDocument () {
      const self = this
      const formData = new FormData()
      formData.append('name', self.newFile.name === '' ? self.newFile.file.name : self.newFile.name)
      formData.append('category_id', 'cfdc77b5-827b-4494-8c6c-c99a36b40abf')
      formData.append('category', 'Agency')
      formData.append('documentable_id', this.$store.state.agencies.agency.id)
      formData.append('documentable_type', 'App\\Agency')
      formData.append('file', self.newFile.file)
      formData.append('public', true)
      axios.post(self.URLs.core.documents.root, formData).then(response => {
        self.documentCopy.push({
          id: response.data.id,
          name: self.newFile.name === '' ? self.newFile.file.name : self.newFile.name
        })
        self.addDialog = false
        self.newFile = { name: '', file: undefined }
        self.$store.dispatch('documents/setAgencyDocuments')
        self.$emit('newDocument', self.documentCopy)
      }).catch(error => {
        self.errors = error.response.data.errors
      })
    },
    openExistingDocumentDialog () {
      this.existingDialog = true
    },
    addExistingDocument () {
      try {
        axios.post('/api/documents/publicise', this.search)
          .then(response => {
            this.documentCopy.push(this.search)
            this.existingDialog = false
            this.search = ''
            this.$emit('newDocument', this.documentCopy)
          })
      } catch (error) {
        console.log(error)
      }
    },
    removeOption (index) {
      this.documentCopy.splice(index, 1)
    }
  }
}
</script>
<style lang="scss">

</style>
